import type { Academy } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useAcademy,
  useFind: useAcademies,
  useCreate: useAcademyCreation,
  useUpdate: useAcademyUpdate,
} = getCRUDHooks<Academy>({
  entityName: 'academies',
  getHelper: () => clientApi.getOCClient().helpers.learningContent.academies,
});

export { useAcademy, useAcademies, useAcademyCreation, useAcademyUpdate };
